export const STATIC_ACCESS_TYPES = {
    kiosk: 'Call',
    operator: 'Operator',
    scan: 'Access Key',
    visitor: 'Visitor',
    lpr: 'LPR',
    ca4k: 'CA4K',
    emergency: 'Emergency',
    code: 'Code'
};
